import styled from "styled-components/macro";

export const Section = styled.section<{ bgImage?: string }>`
  width: 100%;
  height: 550px;
  background-image: ${({ bgImage }) => bgImage ? `url(${bgImage})` : "none"};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 30px;
  //padding-top: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 80px;
    
  @media (max-width: 1439px) {
    height: 540px;
    margin-bottom: 40px;
  }

  @media (max-width: 979px) {
    padding: 40px 12px 0;
    border-radius: 0;
    justify-content: flex-start;
  }
`;

export const MainTitle = styled.h2`
  font-family: "Cormorant Infant", sans-serif;
  font-size: 65px;
  font-weight: 600;
  line-height: 105%;
  color: #fff;
  text-align: center;
  margin-bottom: 36px;
  max-width: 960px;

  @media (max-width: 1439px) {
    font-size: 45px;
  }

  @media (max-width: 979px) {
    font-size: 38px;
    margin-bottom: 40px;
  }
`

export const Text = styled.p`
  font-size: 22px;
  color: #fff;
  line-height: 140%;
  letter-spacing: -0.02em;
  max-width: 628px;
  text-align: center;
  margin-bottom: 36px;

  @media (max-width: 1439px) {
    font-size: 20px;
  }

  @media (max-width: 979px) {
    font-size: 16px;
  }
`
